import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IUser, IUserRequest } from './users.models';
import { Observable } from 'rxjs';
import { IUserProfile } from '../../state/current-user/current-user.model';
import { IProcessPartnerAssignmentRequest } from '../process-partners/process-partners.models';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private readonly http = inject(HttpClient);

  public getUsers(): Observable<IUser[]> {
    return this.http.get<IUser[]>(
      `${environment.services.masterdata}/api/users`
    );
  }

  public getCurrentUser(): Observable<IUserProfile> {
    return this.http.get<IUserProfile>(
      `${environment.services.masterdata}/api/users/profile`
    );
  }

  public getUserById(id: number): Observable<IUserRequest> {
    return this.http.get<IUser>(
      `${environment.services.masterdata}/api/users/${id}`
    );
  }

  public createUser(body: IUserRequest): Observable<IUser> {
    return this.http.post<IUser>(
      `${environment.services.masterdata}/api/users`,
      body,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
  }

  public updateUser(
    userId: number,
    countryId: number,
    body: Partial<IUser>
  ): Observable<IUser> {
    return this.http.put<IUser>(
      `${environment.services.masterdata}/api/users/${userId}/countries/${countryId}`,
      { ...body },
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
  }

  public assignProcessPartners(
    userId: number,
    countryId: number,
    processPartners: IProcessPartnerAssignmentRequest[]
  ): Observable<IUser> {
    return this.http.put<IUser>(
      `${environment.services.masterdata}/api/users/${userId}/countries/${countryId}/assign-process-partners`,
      processPartners
    );
  }

  public assignSurveyPoints(
    userId: number,
    countryId: number,
    surveyPointIds: number[]
  ): Observable<IUser> {
    return this.http.put<IUser>(
      `${environment.services.masterdata}/api/users/${userId}/countries/${countryId}/assign-survey-points`,
      surveyPointIds
    );
  }

  public switchCountry(countryId: number): Observable<IUserProfile> {
    return this.http.put<IUserProfile>(
      `${environment.services.masterdata}/api/users/switch-country/${countryId}`,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }
  public switchLanguage(lang: string): Observable<void> {
    return this.http.put<void>(
      `${environment.services.masterdata}/api/users/switch-language/${lang}`,
      {},
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  public startImpersonateUser(userId: number): Observable<void> {
    return this.http.put<void>(
      `${environment.services.masterdata}/api/users/impersonate/start/${userId}`,
      {}
    );
  }

  public stopImpersonateUser(): Observable<void> {
    return this.http.put<void>(
      `${environment.services.masterdata}/api/users/impersonate/stop`,
      {}
    );
  }
}
